import { Button, Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Color } from '../../../Common/Color'
import { StopOutlined, LikeOutlined, CommentOutlined } from '@ant-design/icons'
import { formatPhoneNumberIntl } from 'react-phone-number-input'

export default function MobileConfirmedAppointment ({ box, appointment, onCancel, appointmentStatus }) {
  const { t } = useTranslation()

  const style = {
    boxShadow: '0px 0px 2px 2px #f2f2f2',
    borderRadius: '1em',
    padding: '1em',
    textAlign: 'center',
    maxWidth: '400px',
    margin: 'auto'
  }

  return (
    <div>
      <div style={style}>
        {(!['cancel', 'timeout', 'clean_in_progress', 'done'].includes(appointmentStatus)) &&
          <>
            {(['late', 'in_progress', 'person_left'].includes(appointmentStatus)) &&
              <>
                <CommentOutlined style={{ fontSize: '32px', margin: '1em' }} />
                <div style={{ color: Color.red }}>{t('Public.ConfirmedAppointment.ongoing')}</div>
              </>
            }
            <div>{t('Public.ConfirmedAppointment.description')}</div>
            <Input style={{ margin: '2em 3em', color: Color.red, textAlign: 'center', letterSpacing: '0.5em', width: '170px', fontWeight: 'bold', fontSize: '1.5em' }}
              value={appointment.digicode} disabled={true} id='digicode' />
            { appointmentStatus === 'waiting' &&
              <Button type="primary" htmlType="submit" onClick={() => onCancel()}>
                {t('Public.ConfirmedAppointment.cancel')}
              </Button>
            }
          </>
        }
        {(['clean_in_progress', 'done'].includes(appointmentStatus)) &&
          <>
            <LikeOutlined style={{ fontSize: '32px', margin: '1em' }} />
            <div style={{ color: Color.red }}>{t('Public.ConfirmedAppointment.done')}</div>
          </>
        }
        {(appointmentStatus === 'cancel') &&
          <>
            <StopOutlined style={{ fontSize: '32px', margin: '1em' }} />
            <div style={{ color: Color.red }}>{t('Public.ConfirmedAppointment.canceled')}</div>
          </>
        }
        {(appointmentStatus === 'timeout') &&
          <>
            <div>{t('Public.ConfirmedAppointment.timeout')}</div>
          </>
        }

      </div>
      {(appointmentStatus === 'waiting') &&
        <div style={{ ...style, maxWidth: '400px', marginTop: '1em' }} >
          <p>
            {t('Public.ConfirmedAppointment.information.line1', { pcc_phone: formatPhoneNumberIntl(appointment.box.pcc_phone) })}
            <a href="mailto:vigilance@laboxmedicale.com" className="btn btn-primary">vigilance@laboxmedicale.com</a>
          </p>
          <p>{t('Public.ConfirmedAppointment.information.line2')}</p>
          <p>{t('Public.ConfirmedAppointment.information.line3')}</p>
          <p>{t(`Public.ConfirmedAppointment.${box?.teleconsulting_company_name}.description`)}</p>
          <a href={box.teleconsulting_company_url} target='_blank' rel="noreferrer">
            <Button size='large' style={{ fontWeight: 'bold' }} >{t(`Public.ConfirmedAppointment.${box?.teleconsulting_company_name}.button`)}</Button>
          </a>
        </div>
      }
    </div >
  )
}
